import { ca } from '@cian/analytics';

import { TTrackingUser } from '../../common/utils/analytics/getTrackingUser';

type TTrackPageviewParams = {
  jsonQuery?: any;
  user: TTrackingUser;
};

export const trackPageview = ({ jsonQuery, user }: TTrackPageviewParams) => {
  // @ts-expect-error В данном случае нам просто нужно отослать еще раз pageview c новым jsonQuery
  const page = window.CianAnalytics?.service.config.page;

  if (page) {
    ca('pageviewSite', {
      page,
      user,
      sc: jsonQuery,
    });
  }
};
